import React from "react";
import {Stack} from "@mui/material";
import {styles} from '../Utilities/ProactiveMetricsDetailStyles';
import {HeaderLabel} from "./HeaderLabel";
import {HeaderFormFields} from "../Forms/HeaderFormFields";
import moduleStyles from "../Utilities/styles.module.css"

export const Header = ({
    pageFilter,
    isFilterDropdownOpen,
    setIsFilterDropdownOpen,
    isCampaignNameDropdownOpen,
    setIsCampaignNameDropdownOpen,
    selectedCriteria,
    setSelectedCriteria,
    filterRef,
    filterPageRef,
    handleExport,
    selectedDropdownOption,
    onSelectChangeHandler,
    onFilterFormSubmit,
    handleFilterReset,
    dateRange,
    setDateRange,
    extractedCampaignList,
    setLiked,
    setReplied,
    setNoEngagement,
    setFollowed,
    setConverted,
    setFollowUpSent,
    setConvertedAfterFollowUpSent,
    setHasAdditionalOrders,
    setOrderedWithin5Days,
    setOrderedRecommendedCategory,
    setOrderedRecommendedProduct,
    setUsedDiscount,
    setUsedExactDiscountCode,
    setLastTouch,
}) => {

    return (
        <>
            <Stack direction={'column'} sx={styles.header} spacing={2} className={moduleStyles.pt55}>
               <HeaderLabel pageFilter={pageFilter}  />
               <HeaderFormFields
                   pageFilter={pageFilter}
                   isFilterDropdownOpen={isFilterDropdownOpen}
                   setIsFilterDropdownOpen={setIsFilterDropdownOpen}
                   isCampaignNameDropdownOpen={isCampaignNameDropdownOpen}
                   setIsCampaignNameDropdownOpen={setIsCampaignNameDropdownOpen}
                   selectedCriteria={selectedCriteria}
                   setSelectedCriteria={setSelectedCriteria}
                   filterRef={filterRef}
                   filterPageRef={filterPageRef}
                   handleExport={handleExport}
                   selectedDropdownOption={selectedDropdownOption}
                   onSelectChangeHandler={onSelectChangeHandler}
                   onFilterFormSubmit={onFilterFormSubmit}
                   handleFilterReset={handleFilterReset}
                   dateRange={dateRange}
                   setDateRange={setDateRange}
                   extractedCampaignList={extractedCampaignList}
                   setLiked={setLiked}
                   setReplied={setReplied}
                   setNoEngagement={setNoEngagement}
                   setFollowed={setFollowed}
                   setConverted={setConverted}
                   setFollowUpSent={setFollowUpSent}
                   setConvertedAfterFollowUpSent={setConvertedAfterFollowUpSent}
                   setHasAdditionalOrders={setHasAdditionalOrders}
                   setOrderedWithin5Days={setOrderedWithin5Days}
                   setOrderedRecommendedCategory={setOrderedRecommendedCategory}
                   setOrderedRecommendedProduct={setOrderedRecommendedProduct}
                   setUsedDiscount={setUsedDiscount}
                   setUsedExactDiscountCode={setUsedExactDiscountCode}
                   setLastTouch={setLastTouch}
               />
            </Stack>
        </>
    )
}